import ubBanzai from 'ub/control/banzai-features';
import googleFontsApi from 'ub/fonts/font-service/google/api';
import FontPickerStateController from 'ub/fonts/font-picker/state-controller';
import fontBuilder from './font-builder';

const timeBuffer = ubBanzai.getFeatureValue('fontTimeBuffer');
const countBuffer = ubBanzai.getFeatureValue('fontCountBuffer');
const EMPTY_LENGTH = 0;

FontPickerStateController.stateChangedSubject
  .subscribe(fontBuilder.render);

googleFontsApi.subject
  .map((ev) => { return ev.fontFamily; })
  .bufferWithTimeOrCount(timeBuffer, countBuffer)
  .filter((ev) => { return ev.length > EMPTY_LENGTH; }) // Prevents emitting empty buffer
  .subscribe((loadedFonts) => {
    FontPickerStateController.modalActionsSubject.onNext({
      type: 'showFonts',
      data: loadedFonts
    });
  });

const open = () => {
  FontPickerStateController.modalActionsSubject.onNext({type: 'renderInitialState'});
};

const close = () => {
  FontPickerStateController.modalActionsSubject.onNext({type: 'closeModal'});
};

export default {
  close,
  open
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-picker.jsx